<app-menu direction="horizontal">
    <ng-container *ngFor="let item of items">
        <app-menu-item appearance="link" *ngIf="item.show" [goTo]="item.url || openUrl" [badge]="item.count" [size]="menuSize.Small">{{
            item.title | translate
        }}</app-menu-item>
    </ng-container>
</app-menu>
